import logo from "./logo.svg";
import "./App.css";

import Header from "./comp/Header.js";

import Footer from "./comp/Footer.js";
import AdvertiserForm from "./comp/AdvertiserForm.js";
import DriverForm from "./comp/DriverForm.js";
import Index from "./comp/Index.js";

import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import {Analytics} from "@vercel/analytics/react"

function App() {
    return (
        <div className="App">


            <Router>
                <Header/>
                <Routes>
                    <Route path="/" element={<Index/>}/>
                    <Route path="/advertisers" element={<AdvertiserForm/>}/>
                    <Route path="/drivers" element={<DriverForm/>}/>

                </Routes>
                <Footer/>
            </Router>
            <Analytics/>
        </div>
    );
}

export default App;
